import { DraftConfiguration } from '@/types';
import { StoreState } from '@/redux/types';
import { getConfigurationErrors } from './getConfigurationErrors';

export function getErrorForConfiguration(state: StoreState, { cid }: DraftConfiguration) {
  const configurationErrors = getConfigurationErrors(state, cid);
  if (configurationErrors) {
    return Object.entries(configurationErrors).find(([, error]) => Boolean(error));
  }
}
